import React, { useState } from "react";
import "./Sidebar.css";
import { Link } from "react-router-dom";

import CadastrosIcon from "../../../assets/icons/perfil.png";
import HorariosIcon from "../../../assets/icons/horario.png";
import AgendaIcon from "../../../assets/icons/agenda.png";
import VendasIcon from "../../../assets/icons/vendas.png";
import ComprasIcon from "../../../assets/icons/produtos.png";
import FinanceiroIcon from "../../../assets/icons/financeiro.png";
import ConfigIcon from "../../../assets/icons/configuracoes.png";
import RelatoriosIcon from "../../../assets/icons/relatorio.png";
import DashboardIcon from "../../../assets/icons/dashboard.png";


const Sidebar = ({ onSelect }) => {
  const [activeGroup, setActiveGroup] = useState(null);

  const menu = [
    {
      id: "dashboard",
      label: "Tarefas",
      icon: <img src={DashboardIcon} alt="Dashboard" className="Sidebar-icon" />,
      items: [
        { label: "Tarefas", value: "dashboard" }
      ],
    },
    {
      id: "agenda",
      label: "Agenda",
      icon: <img src={AgendaIcon} alt="Agenda" className="Sidebar-icon" />,
      items: [
        { label: "Agendamentos", value: "agendamentos" },
        { label: "Pacotes", value: "pacotes" }, 
        { label: "Cancelamentos", value: "cancelamentos" },
        { label: "Faltas", value: "faltas" },
      ],
    },
    {
      id: "cadastros",
      label: "Cadastros",
      icon: <img src={CadastrosIcon} alt="Cadastros" className="Sidebar-icon" />,
      items: [
        { label: "Cadastros", value: "cadastros" },
        { label: "Permissões", value: "permissao" },
        { label: "Avisos", value: "avisos" },
        { label: "Especialidades", value: "especialidades" },
      ],
    },
    {
      id: "horarios",
      label: "Horários",
      icon: <img src={HorariosIcon} alt="Horários" className="Sidebar-icon" />,
      items: [
        { label: "Horarios", value: "horarios" },
        { label: "Bloqueios", value: "horariosfechamento" },
      ],
    },
    {
      id: "vendas",
      label: "Vendas",
      icon: <img src={VendasIcon} alt="Vendas" className="Sidebar-icon" />,
      items: [
        { label: "Vendas", value: "vendas" },
        { label: "Produtos", value: "produtos" },
        { label: "Estoque", value: "estoque" },
        { label: "Forma de Pagamento", value: "formapagto" },
      ],
    },
    {
      id: "compras",
      label: "Compras",
      icon: <img src={ComprasIcon} alt="Compras" className="Sidebar-icon" />,
      items: [
        { label: "Compras", value: "compras" },
        { label: "Fornecedores", value: "fornecedores" },
        { label: "Categorias de Fornecedores", value: "fornecedorescategorias" },
      ],
    },
    {
      id: "financeiro",
      label: "Financeiro",
      icon: <img src={FinanceiroIcon} alt="Financeiro" className="Sidebar-icon" />,
      items: [
        { label: "Receitas", value: "receitas" },
        { label: "Despesas", value: "despesas" },
        { label: "Itens Despesas", value: "despesasitens" },
        { label: "Categorias Despesas", value: "despesascategorias" },
      ],
    },
    {
      id: "relatorios",
      label: "Relatórios",
      icon: <img src={RelatoriosIcon} alt="Relatórios" className="Sidebar-icon" />,
      items: [
        { label: "Relatórios", value: "relatorios" },
      ],
    },
    {
      id: "configuracoes",
      label: "Configurações",
      icon: <img src={ConfigIcon} alt="Configurações" className="Sidebar-icon" />,
      items: [
        { label: "Configurações", value: "configuracoes" },
        { label: "Dados Responsável", value: "dados" },
      ],
    },
  ];

  const toggleGroup = (groupId) => {
    setActiveGroup(activeGroup === groupId ? null : groupId);
  };

  const renderGroupLabel = (section) => {
    return (
      <div className="Sidebar-group-label" id={section.id}>
        {section.icon}
        <div className="Sidebar-group-label-text">{section.label}</div>
      </div>
    );
  };

  return (
    <div className="Sidebar-container">
      <div className="Sidebar-titulo">Gerenciamento</div>

      {menu.map((section, index) => (
        <div key={index} className="Sidebar-section">
          <div
            className={`Sidebar-group ${
              activeGroup === section.id ? "active" : ""
            }`}
            onClick={() => toggleGroup(section.id)}
          >
            {renderGroupLabel(section)}
          </div>

          {activeGroup === section.id && (
            <div className="Sidebar-subitems">
              {section.items.map((item, idx) => (
                <div
                  key={idx}
                  className="Sidebar-item"
                  onClick={() => onSelect && onSelect(item)}
                >
                  {item.label}
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Sidebar;
